module.exports = __webpack_public_path__ + "img/yellow-red-line.b9063982.svg";